import { inject, Injectable } from '@angular/core'
import { environment } from '@env'
import { Smartlook } from '@awesome-cordova-plugins/smartlook/ngx'
import { UserProfile } from '@core/auth/models/auth.models'

@Injectable({ providedIn: 'root' })
export class SmartlookService {
  private readonly _smartlook: Smartlook = inject(Smartlook)
  constructor() {
    this._smartlook.setProjectKey({ key: environment.smartlookApiKey })
  }

  init(user: UserProfile, granted: boolean) {
    this._smartlook.setUserIdentifier({ identifier: user.userId })
    if (granted) {
      this._smartlook.setUserEmail({ email: user.email })
    }
    this._smartlook.start()
  }
}
